// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-tabs .nav-link[data-v-fc987a88] {\n  padding-top: 0rem;\n  padding-bottom: 0.5rem;\n}\n.header-tabs[data-v-fc987a88] {\n  margin-bottom: 0;\n  border-bottom-width: 0;\n}\n.nav[data-v-fc987a88] {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
